import {useEffect} from 'react';
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {useGetOrganizationById} from "@tinct/core-api";
import {useNavigate} from "react-router-dom";

export const OrganizationDispatcherPage = () => {
  const organizationId = useGetCurrentWorkspaceId() as string;
  const navigate = useNavigate();
  const {data: organization, isFetched} = useGetOrganizationById({
    id: organizationId,
    fields: {
      name: null,
      domain: null,
      type: null,
    }
  })

  useEffect(() => {
    if(!isFetched) {
      return;
    }
    // Agencies hold no content: their home is the list of managed workspaces.
    if (organization?.type === 'agency') {
      navigate(`/w/${organizationId}/agency`, {replace: true});
      return;
    }
    if (isFetched && !organization?.domain) {
      navigate(`/w/${organizationId}/brand`, {replace: true});
      return;
    }

    navigate(`/w/${organizationId}/dashboard`, {replace: true});
  }, [isFetched, navigate, organization?.domain, organization?.type, organizationId])


  return (
    <div>
      <h1>Redirecting</h1>
    </div>
  );
};
